import {
  KProperty02ce7r476m8633 as KProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  IncompleteYearMonth32an7l8nqz3oa as IncompleteYearMonth,
  requireParsedField387b2jr94jy2p as requireParsedField,
  year1lgww3hq6k77h as year,
  monthNumber1m6x1k5hwwmv0 as monthNumber,
  monthName3sdgh7ilodr1v as monthName,
  AbstractWithYearMonthBuilder24i9826zzgc8l as AbstractWithYearMonthBuilder,
} from './YearMonthFormat.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  LocalDate31mqn6zavbpi8 as LocalDate,
  plus1et5dysousgt9 as plus,
} from '../LocalDate.mjs';
import { Companion_getInstance3rf6ssn2f6rf5 as Companion_getInstance } from '../DateTimeUnit.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from '../Exceptions.mjs';
import { get_number11nqnpf0wxtuc as get_number } from '../Month.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  DayOfWeek2xlo40o03f5e as DayOfWeek,
  get_isoDayNumberrycq4er3aoh9 as get_isoDayNumber,
} from '../DayOfWeek.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  get_indices3txodfl5wuu5j as get_indices,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { AppendableFormatStructure38mt32f1b8qva as AppendableFormatStructure } from '../internal/format/Builder.mjs';
import {
  appendAlternativeParsingImpl1mug8j87kp2j3 as appendAlternativeParsingImpl,
  appendOptionalImplcg29ds00y54b as appendOptionalImpl,
  chars1g48a4lypizqb as chars,
  build284bs2tzkjm2x as build,
  day$default1tuwold9wyz96 as day$default,
  year$default3mx8s1e4np76f as year$default,
  monthNumber$defaultjiqg7b70p9la as monthNumber$default,
  AbstractDateTimeFormatBuilder2kkelk07l4wb as AbstractDateTimeFormatBuilder,
  WithDate2bqihss8t5xfv as WithDate,
  char1r4ssccmdfesy as char,
} from './DateTimeFormatBuilder.mjs';
import {
  AbstractDateTimeFormat1er9ki1vjeb1b as AbstractDateTimeFormat,
  Padding_ZERO_getInstance165tawgk9tdj7 as Padding_ZERO_getInstance,
  Padding_SPACE_getInstance3jytkjkv2jvr6 as Padding_SPACE_getInstance,
} from './DateTimeFormat.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { BasicFormatStructure1rp1tyv3u2fjw as BasicFormatStructure } from '../internal/format/FormatStructure.mjs';
import {
  UnsignedIntFieldFormatDirective20kfpdbszyixg as UnsignedIntFieldFormatDirective,
  NamedUnsignedIntFieldFormatDirective1yq6ki9eqgm4v as NamedUnsignedIntFieldFormatDirective,
} from '../internal/format/FieldFormatDirective.mjs';
import {
  PropertyAccessor1m9zk65ebkfc4 as PropertyAccessor,
  UnsignedFieldSpec1pqzij1hidkca as UnsignedFieldSpec,
} from '../internal/format/FieldSpec.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_ISO_DATE() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp0 = ISO_DATE$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_DATE', 0, tmp, _get_ISO_DATE_$ref_powsum(), null);
  return tmp0.get_value_j01efc_k$();
}
var ISO_DATE$delegate;
function get_ISO_DATE_BASIC() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp0 = ISO_DATE_BASIC$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_DATE_BASIC', 0, tmp, _get_ISO_DATE_BASIC_$ref_3fs8eb(), null);
  return tmp0.get_value_j01efc_k$();
}
var ISO_DATE_BASIC$delegate;
function get_emptyIncompleteLocalDate() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  return emptyIncompleteLocalDate;
}
var emptyIncompleteLocalDate;
var IncompleteLocalDateClass;
function IncompleteLocalDate() {
  if (IncompleteLocalDateClass === VOID) {
    class $ {
      constructor(yearMonth, day, dayOfWeek, dayOfYear) {
        yearMonth = yearMonth === VOID ? new (IncompleteYearMonth())() : yearMonth;
        day = day === VOID ? null : day;
        dayOfWeek = dayOfWeek === VOID ? null : dayOfWeek;
        dayOfYear = dayOfYear === VOID ? null : dayOfYear;
        this.yearMonth_1 = yearMonth;
        this.day_1 = day;
        this.dayOfWeek_1 = dayOfWeek;
        this.dayOfYear_1 = dayOfYear;
      }
      set_day_420fh8_k$(_set____db54di) {
        this.day_1 = _set____db54di;
      }
      get_day_18j7il_k$() {
        return this.day_1;
      }
      set_dayOfWeek_rlg9ap_k$(_set____db54di) {
        this.dayOfWeek_1 = _set____db54di;
      }
      get_dayOfWeek_3kfgci_k$() {
        return this.dayOfWeek_1;
      }
      set_dayOfYear_b6dvlk_k$(_set____db54di) {
        this.dayOfYear_1 = _set____db54di;
      }
      get_dayOfYear_3ke6gp_k$() {
        return this.dayOfYear_1;
      }
      toLocalDate_u88f42_k$() {
        var year = requireParsedField(this.get_year_woy26e_k$(), 'year');
        var dayOfYear = this.dayOfYear_1;
        var tmp;
        if (dayOfYear == null) {
          tmp = LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(year, requireParsedField(this.get_monthNumber_nb47ls_k$(), 'monthNumber'), requireParsedField(this.day_1, 'day'));
        } else {
          // Inline function 'kotlin.also' call
          var this_0 = plus(LocalDate().new_kotlinx_datetime_LocalDate_81790c_k$(year, 1, 1), dayOfYear - 1 | 0, Companion_getInstance().DAY_1);
          if (!(this_0.year_1 === year)) {
            throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is not a valid day of year for the year ' + year));
          }
          if (!(this.get_monthNumber_nb47ls_k$() == null) && !(get_number(this_0.get_month_ivc8d3_k$()) === this.get_monthNumber_nb47ls_k$())) {
            throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is ' + this_0.get_month_ivc8d3_k$().toString() + ', ') + ('but ' + this.get_monthNumber_nb47ls_k$() + ' was specified as the month number'));
          }
          if (!(this.day_1 == null) && !(this_0.day_1 === this.day_1)) {
            throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is the day ' + this_0.day_1 + ' of ' + this_0.get_month_ivc8d3_k$().toString() + ', ') + ('but ' + this.day_1 + ' was specified as the day of month'));
          }
          tmp = this_0;
        }
        var date = tmp;
        var tmp0_safe_receiver = this.dayOfWeek_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (!(tmp0_safe_receiver === get_isoDayNumber(date.get_dayOfWeek_3kfgci_k$()))) {
            throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Can not create a LocalDate from the given input: ' + ('the day of week is ' + DayOfWeek(tmp0_safe_receiver).toString() + ' but the date is ' + date.toString() + ', which is a ' + date.get_dayOfWeek_3kfgci_k$().toString()));
          }
        }
        return date;
      }
      populateFrom_bxnzqu_k$(date) {
        this.set_year_8yykwv_k$(date.year_1);
        this.set_monthNumber_nufdv5_k$(get_number(date.get_month_ivc8d3_k$()));
        this.day_1 = date.day_1;
        this.dayOfWeek_1 = get_isoDayNumber(date.get_dayOfWeek_3kfgci_k$());
        this.dayOfYear_1 = date.get_dayOfYear_3ke6gp_k$();
      }
      copy_1tks5_k$() {
        return new (IncompleteLocalDate())(this.yearMonth_1.copy_1tks5_k$(), this.day_1, this.dayOfWeek_1, this.dayOfYear_1);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        var tmp_2;
        if (other instanceof IncompleteLocalDate()) {
          tmp_2 = this.yearMonth_1.equals(other.yearMonth_1);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = this.day_1 == other.day_1;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.dayOfWeek_1 == other.dayOfWeek_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.dayOfYear_1 == other.dayOfYear_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var tmp = imul(this.yearMonth_1.hashCode(), 29791);
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.day_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        var tmp_0 = tmp + imul(tmp$ret$0, 961) | 0;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = this.dayOfWeek_1;
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        var tmp$ret$1 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
        var tmp_1 = tmp_0 + imul(tmp$ret$1, 31) | 0;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_1 = this.dayOfYear_1;
        var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
        return tmp_1 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
      }
      toString() {
        var tmp;
        if (this.dayOfYear_1 == null) {
          var tmp_0 = this.yearMonth_1.toString();
          var tmp0_elvis_lhs = this.day_1;
          var tmp_1 = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
          var tmp1_elvis_lhs = this.dayOfWeek_1;
          tmp = tmp_0 + '-' + tmp_1 + ' (day of week is ' + toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs) + ')';
        } else if (this.day_1 == null && this.get_monthNumber_nb47ls_k$() == null) {
          var tmp2_elvis_lhs = this.yearMonth_1.year_1;
          var tmp_2 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
          var tmp_3 = this.dayOfYear_1;
          var tmp3_elvis_lhs = this.dayOfWeek_1;
          tmp = '(' + tmp_2 + ')-' + tmp_3 + ' (day of week is ' + toString(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs) + ')';
        } else {
          var tmp_4 = this.yearMonth_1.toString();
          var tmp4_elvis_lhs = this.day_1;
          var tmp_5 = toString(tmp4_elvis_lhs == null ? '??' : tmp4_elvis_lhs);
          var tmp5_elvis_lhs = this.dayOfWeek_1;
          tmp = tmp_4 + '-' + tmp_5 + ' (day of week is ' + toString(tmp5_elvis_lhs == null ? '??' : tmp5_elvis_lhs) + ', day of year is ' + this.dayOfYear_1 + ')';
        }
        return tmp;
      }
      set_year_8yykwv_k$(_set____db54di) {
        this.yearMonth_1.year_1 = _set____db54di;
      }
      get_year_woy26e_k$() {
        return this.yearMonth_1.year_1;
      }
      set_monthNumber_nufdv5_k$(_set____db54di) {
        this.yearMonth_1.monthNumber_1 = _set____db54di;
      }
      get_monthNumber_nb47ls_k$() {
        return this.yearMonth_1.monthNumber_1;
      }
    }
    initMetadataForClass($, 'IncompleteLocalDate', IncompleteLocalDate);
    IncompleteLocalDateClass = $;
  }
  return IncompleteLocalDateClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ENGLISH_FULL_1 = new (DayOfWeekNames())(listOf(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']));
        this.ENGLISH_ABBREVIATED_1 = new (DayOfWeekNames())(listOf(['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function String$toString$ref() {
  return constructCallableReference((p0) => toString(p0), 1, 0, 22, 'toString');
}
var DayOfWeekNamesClass;
function DayOfWeekNames() {
  if (DayOfWeekNamesClass === VOID) {
    class $ {
      constructor(names) {
        Companion_getInstance_0();
        this.names_1 = names;
        // Inline function 'kotlin.require' call
        if (!(this.names_1.get_size_woubt6_k$() === 7)) {
          var message = 'Day of week names must contain exactly 7 elements';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.collections.forEach' call
        var progression = get_indices(this.names_1);
        var inductionVariable = progression.first_1;
        var last = progression.last_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ix = element;
            // Inline function 'kotlin.text.isNotEmpty' call
            var this_0 = this.names_1.get_c1px32_k$(ix);
            // Inline function 'kotlin.require' call
            if (!(charSequenceLength(this_0) > 0)) {
              var message_0 = 'A day-of-week name can not be empty';
              throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
            }
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < ix)
              do {
                var ix2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'kotlin.require' call
                if (!!(this.names_1.get_c1px32_k$(ix) === this.names_1.get_c1px32_k$(ix2))) {
                  var message_1 = "Day-of-week names must be unique, but '" + this.names_1.get_c1px32_k$(ix) + "' was repeated";
                  throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_1));
                }
              }
               while (inductionVariable_0 < ix);
          }
           while (!(element === last));
      }
      toString() {
        return joinToString(this.names_1, ', ', 'DayOfWeekNames(', ')', VOID, VOID, String$toString$ref());
      }
      equals(other) {
        var tmp;
        if (other instanceof DayOfWeekNames()) {
          tmp = equals(this.names_1, other.names_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.names_1);
      }
    }
    initMetadataForClass($, 'DayOfWeekNames');
    DayOfWeekNamesClass = $;
  }
  return DayOfWeekNamesClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      build_o3smjo_k$(block) {
        var builder = new (Builder())(new (AppendableFormatStructure())());
        block(builder);
        return new (LocalDateFormat())(builder.build_1k0s4u_k$());
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(actualBuilder) {
        this.actualBuilder_1 = actualBuilder;
      }
      get_actualBuilder_7qypdo_k$() {
        return this.actualBuilder_1;
      }
      addFormatStructureForDate_t2v9hh_k$(structure) {
        return this.actualBuilder_1.add_b6pdwl_k$(structure);
      }
      createEmpty_8k9z67_k$() {
        return new (Builder())(new (AppendableFormatStructure())());
      }
    }
    protoOf($).appendAlternativeParsingImpl_9hljk3_k$ = appendAlternativeParsingImpl;
    protoOf($).appendOptionalImpl_725ywl_k$ = appendOptionalImpl;
    protoOf($).chars_pe6iqb_k$ = chars;
    protoOf($).build_1k0s4u_k$ = build;
    protoOf($).addFormatStructureForYearMonth_t4rp63_k$ = addFormatStructureForYearMonth;
    protoOf($).day_pu15qg_k$ = day;
    protoOf($).day$default_z5jqi1_k$ = day$default;
    protoOf($).dayOfWeek_tn8lxa_k$ = dayOfWeek;
    protoOf($).date_aq11yp_k$ = date;
    protoOf($).year_dmdaiv_k$ = year;
    protoOf($).year$default_dp2ctv_k$ = year$default;
    protoOf($).monthNumber_xjkdp7_k$ = monthNumber;
    protoOf($).monthNumber$default_9sd2sh_k$ = monthNumber$default;
    protoOf($).monthName_asbkgr_k$ = monthName;
    initMetadataForClass($, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder(), AbstractWithDateBuilder()]);
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocalDateFormatClass;
function LocalDateFormat() {
  if (LocalDateFormatClass === VOID) {
    class $ extends AbstractDateTimeFormat() {
      constructor(actualFormat) {
        super();
        this.actualFormat_1 = actualFormat;
      }
      get_actualFormat_d0ha3y_k$() {
        return this.actualFormat_1;
      }
      intermediateFromValue_zbgnn0_k$(value) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IncompleteLocalDate())();
        this_0.populateFrom_bxnzqu_k$(value);
        return this_0;
      }
      intermediateFromValue_816pep_k$(value) {
        return this.intermediateFromValue_zbgnn0_k$(value instanceof LocalDate() ? value : THROW_CCE());
      }
      valueFromIntermediate_ehjimk_k$(intermediate) {
        return intermediate.toLocalDate_u88f42_k$();
      }
      valueFromIntermediate_60ox3m_k$(intermediate) {
        return this.valueFromIntermediate_ehjimk_k$(intermediate instanceof IncompleteLocalDate() ? intermediate : THROW_CCE());
      }
      get_emptyIntermediate_lysuyr_k$() {
        return get_emptyIncompleteLocalDate();
      }
    }
    initMetadataForClass($, 'LocalDateFormat');
    LocalDateFormatClass = $;
  }
  return LocalDateFormatClass;
}
function addFormatStructureForYearMonth(structure) {
  this.addFormatStructureForDate_t2v9hh_k$(structure);
}
function day(padding) {
  return this.addFormatStructureForDate_t2v9hh_k$(new (BasicFormatStructure())(new (DayDirective())(padding)));
}
function dayOfWeek(names) {
  return this.addFormatStructureForDate_t2v9hh_k$(new (BasicFormatStructure())(new (DayOfWeekDirective())(names)));
}
function date(format) {
  return this.addFormatStructureForDate_t2v9hh_k$((format instanceof LocalDateFormat() ? format : THROW_CCE()).actualFormat_1);
}
var AbstractWithDateBuilderClass;
function AbstractWithDateBuilder() {
  if (AbstractWithDateBuilderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AbstractWithDateBuilder', VOID, VOID, [AbstractWithYearMonthBuilder(), WithDate()]);
    AbstractWithDateBuilderClass = $;
  }
  return AbstractWithDateBuilderClass;
}
var DayDirectiveClass;
function DayDirective() {
  if (DayDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = DateFields_getInstance().day_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.padding_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof DayDirective()) {
          tmp = this.padding_1.equals(other.padding_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.padding_1.hashCode();
      }
    }
    initMetadataForClass($, 'DayDirective');
    DayDirectiveClass = $;
  }
  return DayDirectiveClass;
}
var DayOfWeekDirectiveClass;
function DayOfWeekDirective() {
  if (DayOfWeekDirectiveClass === VOID) {
    class $ extends NamedUnsignedIntFieldFormatDirective() {
      constructor(names) {
        super(DateFields_getInstance().isoDayOfWeek_1, names.names_1, 'dayOfWeekName');
        this.names_1 = names;
      }
      equals(other) {
        var tmp;
        if (other instanceof DayOfWeekDirective()) {
          tmp = equals(this.names_1.names_1, other.names_1.names_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.names_1.names_1);
      }
    }
    initMetadataForClass($, 'DayOfWeekDirective');
    DayOfWeekDirectiveClass = $;
  }
  return DayOfWeekDirectiveClass;
}
function DateFieldContainer$_get_day_$ref_2ebhxx() {
  return constructCallableReference((p0) => p0.get_day_18j7il_k$(), 1, 0, 23);
}
function DateFieldContainer$_set_day_$ref_s0jsax() {
  return constructCallableReference((p0, p1) => {
    p0.set_day_420fh8_k$(p1);
    return Unit_instance;
  }, 2, 0, 24);
}
function DateFieldContainer$_get_dayOfWeek_$ref_thwqom() {
  return constructCallableReference((p0) => p0.get_dayOfWeek_3kfgci_k$(), 1, 0, 25);
}
function DateFieldContainer$_set_dayOfWeek_$ref_ea586a() {
  return constructCallableReference((p0, p1) => {
    p0.set_dayOfWeek_rlg9ap_k$(p1);
    return Unit_instance;
  }, 2, 0, 26);
}
function DateFieldContainer$_get_dayOfYear_$ref_2m6gfz() {
  return constructCallableReference((p0) => p0.get_dayOfYear_3ke6gp_k$(), 1, 0, 27);
}
function DateFieldContainer$_set_dayOfYear_$ref_cll22d() {
  return constructCallableReference((p0, p1) => {
    p0.set_dayOfYear_b6dvlk_k$(p1);
    return Unit_instance;
  }, 2, 0, 28);
}
var DateFieldsClass;
function DateFields() {
  if (DateFieldsClass === VOID) {
    class $ {
      constructor() {
        DateFields_instance = this;
        var tmp = this;
        var tmp_0 = KMutableProperty1();
        var tmp_1 = DateFieldContainer$_get_day_$ref_2ebhxx();
        tmp.day_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('day', 1, tmp_0, tmp_1, DateFieldContainer$_set_day_$ref_s0jsax())), 1, 31);
        var tmp_2 = this;
        var tmp_3 = KMutableProperty1();
        var tmp_4 = DateFieldContainer$_get_dayOfWeek_$ref_thwqom();
        tmp_2.isoDayOfWeek_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('dayOfWeek', 1, tmp_3, tmp_4, DateFieldContainer$_set_dayOfWeek_$ref_ea586a())), 1, 7);
        var tmp_5 = this;
        var tmp_6 = KMutableProperty1();
        var tmp_7 = DateFieldContainer$_get_dayOfYear_$ref_2m6gfz();
        tmp_5.dayOfYear_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('dayOfYear', 1, tmp_6, tmp_7, DateFieldContainer$_set_dayOfYear_$ref_cll22d())), 1, 366);
      }
    }
    initMetadataForObject($, 'DateFields');
    DateFieldsClass = $;
  }
  return DateFieldsClass;
}
var DateFields_instance;
function DateFields_getInstance() {
  if (DateFields_instance === VOID)
    new (DateFields())();
  return DateFields_instance;
}
function ISO_DATE$delegate$lambda() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp = Companion_instance_0;
  return tmp.build_o3smjo_k$(ISO_DATE$delegate$lambda$lambda);
}
function ISO_DATE$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  $this$build.year$default_dp2ctv_k$();
  char($this$build, _Char___init__impl__6a9atx(45));
  $this$build.monthNumber$default_9sd2sh_k$();
  char($this$build, _Char___init__impl__6a9atx(45));
  $this$build.day$default_z5jqi1_k$();
  return Unit_instance;
}
function _get_ISO_DATE_$ref_powsum() {
  return constructCallableReference(() => get_ISO_DATE(), 0, 0, 29);
}
function ISO_DATE_BASIC$delegate$lambda() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp = Companion_instance_0;
  return tmp.build_o3smjo_k$(ISO_DATE_BASIC$delegate$lambda$lambda);
}
function ISO_DATE_BASIC$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  $this$build.year$default_dp2ctv_k$();
  $this$build.monthNumber$default_9sd2sh_k$();
  $this$build.day$default_z5jqi1_k$();
  return Unit_instance;
}
function _get_ISO_DATE_BASIC_$ref_3fs8eb() {
  return constructCallableReference(() => get_ISO_DATE_BASIC(), 0, 0, 30);
}
var properties_initialized_LocalDateFormat_kt_fmnlhc;
function _init_properties_LocalDateFormat_kt__k1uk9u() {
  if (!properties_initialized_LocalDateFormat_kt_fmnlhc) {
    properties_initialized_LocalDateFormat_kt_fmnlhc = true;
    ISO_DATE$delegate = lazy(ISO_DATE$delegate$lambda);
    ISO_DATE_BASIC$delegate = lazy(ISO_DATE_BASIC$delegate$lambda);
    emptyIncompleteLocalDate = new (IncompleteLocalDate())();
  }
}
//region block: init
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstance2lv012sehjn6z,
  Companion_instance_0 as Companion_instanceoupd8pza72e0,
  String$toString$ref as String$toString$ref18apr2asyof4x,
  addFormatStructureForYearMonth as addFormatStructureForYearMonth2jef3q6pdb658,
  date as date3ki45iw426xr8,
  dayOfWeek as dayOfWeek16trujebvwhwq,
  day as day1ffm1rpsbzq2v,
  AbstractWithDateBuilder as AbstractWithDateBuilder1xwo9aqwqe32f,
  get_ISO_DATE as get_ISO_DATE1ah0stqy13618,
  get_ISO_DATE_BASIC as get_ISO_DATE_BASIC1k4wiybcckf8,
  IncompleteLocalDate as IncompleteLocalDate2wlnrm8wqbjky,
};
//endregion

//# sourceMappingURL=LocalDateFormat.mjs.map
